import { getReferrerOrigin } from "./referrerOrigin";
import { SHARE_REFERRER_PARAMETER } from "./shareVisitReferrer";

/** Leave the backend's picks wrapper before auth or analytics starts. */
export function redirectProductShareFrame(
  browser: Pick<Window, "location" | "top"> = window,
): boolean {
  const top = browser.top;
  if (!top || top === browser) return false;

  try {
    const current = new URL(browser.location.href);
    const match = current.pathname.match(/^\/product-share\/([^/]+)\/?$/);
    if (!match || match[1] === "dev-preview") return false;

    // Only our same-origin wrapper for this exact token may replace the top page.
    // Reading a third-party parent throws; leave other embeds alone.
    const parent = new URL(top.location.href);
    if (
      parent.origin !== current.origin
      || parent.pathname.replace(/\/$/, "") !== `/picks/${match[1]}`
    ) return false;

    const destination = new URL(parent.href);
    destination.pathname = current.pathname;
    // Preserve outer queries/fragments and frame-only values; the shared URL takes priority.
    current.searchParams.forEach((value, key) => {
      if (!parent.searchParams.has(key)) destination.searchParams.append(key, value);
    });
    destination.hash = parent.hash || current.hash;
    // Prefer the backend handoff, including an explicit direct visit. Older wrappers use the parent document.
    const forwardedReferrer = current.searchParams.get(SHARE_REFERRER_PARAMETER);
    const forwardedOrigin = forwardedReferrer === null ? "" : getReferrerOrigin(forwardedReferrer);
    const originalReferrer = forwardedReferrer === "" || forwardedOrigin
      ? forwardedOrigin : getReferrerOrigin(top.document.referrer);
    destination.searchParams.set(SHARE_REFERRER_PARAMETER, originalReferrer);
    top.location.replace(destination.href);
    return true;
  } catch {
    return false;
  }
}
